export default {
  namespaced: true,
  name: "culture",
  state: {
    CATEGORY: [{}, {}, {}],
    WORKLISTCATEGORY: [],
    WAYCATEGORY: [],
    FYCATEGORY: [],
  },
  getters: {
    GET_MATERIA_DATA(state) {
      return state.CATEGORY[0]
    },
    GET_PROCESS_DATA(state) {
      return state.CATEGORY[1]
    },
    GET_TOOL_DATA(state) {
      return state.CATEGORY[2]
    },
  },
  mutations: {
    SET_CATEGORY(state, data) {
      state.CATEGORY = data
    },
    SET_WORKLISTCATEGORY(state, data) {
      state.WORKLISTCATEGORY = data
    },
    SET_WAYCATEGORY(state, data) {
      state.WAYCATEGORY = data
    },
    SET_FYCATEGORY(state, data) {
      state.FYCATEGORY = data
    },
  },
  actions: {
    // 获取材料
  },
}
